export default __webpack_public_path__ + "static/media/announcement_1@3x.fc7e164d.png";